import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

function fmtReviewDate(iso) {
  if (!iso) return new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" });
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
}

export default function ReviewedBy({ date, reviewer = "Dileshwar Vitthale" }) {
  const display = fmtReviewDate(date);
  const iso = date ? String(date).slice(0, 10) : new Date().toISOString().slice(0, 10);
  return (
    <div
      data-testid="reviewed-by"
      className="mt-4 flex flex-wrap items-center gap-2 text-xs text-slate-600 bg-green-50 border border-green-200 rounded-md px-3 py-2"
      itemScope
      itemType="https://schema.org/Person"
    >
      <ShieldCheck className="w-4 h-4 text-green-700 shrink-0" aria-hidden="true" />
      <span>
        Last reviewed by{" "}
        <Link to="/about" className="font-semibold text-slate-900 hover:text-orange-600" itemProp="name">
          {reviewer}
        </Link>
        , Chief Editor on{" "}
        <time dateTime={iso} itemProp="reviewedDate" className="font-semibold text-slate-900">
          {display}
        </time>
      </span>
      <span className="hidden sm:inline text-slate-400">·</span>
      <span className="text-green-800 font-semibold">Verified against official source</span>
    </div>
  );
}
